import axios from "axios";
import Vue from "vue";

window.Vue = Vue;

window.addEventListener("DOMContentLoaded", function () {


    new Vue({
        el: "#job_form",
        data: function () {
            return {
                first_name:'',
                last_name:'',
                additional_information:'',
                cv:'',
                country:'',
                motivational_letter:'',
                email:'',
                phone:'',
                message:'',
                prefix:"40",
                errorMessage_phone:'',
                errorMessage_name:'',
                errorMessage_email:'',
                errorMessage_message:'',
                isActiveForm:false,
                loading:false,
                responseText:false,
                title_job:'',
                email_list:'',
                description_job:'',
                current_cv_file:'',
                current_ml_file:'',
                errorMessage_cv:'',
                errorMessage_ml:'',
                errorMessage_checkbox_agree_condition:"",
                checkbox_agreement:"",
            };
        },
        methods: {
            activateForm(job){
                this.isActiveForm = true;
                this.title_job=job['title'];
                this.description_job=job['description'];
                this.email_list=job['email_list'];
            },
            sendEmail(language){

                const vm = this;
                var phoneNumber =  vm.formatRomaniaPhoneNumber(vm.phone);
                var checkValid = true;
                var email=vm.validateEmail(vm.email);
                if(vm.email !=null && vm.email !='' && !email ){
                    checkValid =false;
                    vm.errorMessage_email = "Not valid";
                }
                else{
                    vm.errorMessage_email = "";
                }
                if (vm.phone!=null && this.phone!='' && !vm.validatePhoneNumber(phoneNumber)) {
                    checkValid = false;
                    vm.errorMessage_phone = "Not valid";
                } else {
                    vm.errorMessage_phone = "";
                }
                if (!vm.checkbox_agreement) {
                    vm.errorMessage_checkbox_agree_condition = "can't be empty";
                    checkValid =false;
                } else {
                    vm.errorMessage_checkbox_agree_condition = "";
                }
                if(vm.current_cv_file == null || vm.current_cv_file==''){
                    checkValid = false;
                    vm.errorMessage_cv = "Not valid";
                }else{
                    vm.errorMessage_cv = "";

                }
                
                if(checkValid)
                {
                    vm.loading = true;
                    vm.responseText = false;
            
                     axios
                    .post("/api/sendJobApplication",{
                        first_name:vm.first_name,
                        last_name:vm.last_name,
                        email:vm.email,
                        phone:phoneNumber,
                        message:vm.message,
                        language:language,
                        cv:vm.current_cv_file,
                        ml:vm.current_ml_file,
                        job:vm.title_job,
                        description:vm.description_job,
                        email_list:vm.email_list
                    })
                    .then((response) => {
                        vm.responseText = true;
                        this.isActiveForm = false;

                    })
                    .catch((error)=>{
                        vm.responseText =false;
                    })
                    .then(()=>{
                        vm.loading=false;
                    });
                }   
                },

             validatePhoneNumber(str) {
                var phoneNumber = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,8}$/im.test(str);
                return phoneNumber;
              },

              formatRomaniaPhoneNumber(str) {
                let phoneNumber = str.replace(/\D/g, '');
                if(phoneNumber.length==10 && phoneNumber[0]==0){
                    phoneNumber = "4"+phoneNumber;
                }
                if(phoneNumber.length==9 && phoneNumber[0]==7){
                    phoneNumber = "40"+phoneNumber;
                }
                return phoneNumber;
              },
              
              validateEmail(str){
                var email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str);
                return email;
              },
              async uploadToServer( event,type_file) {
                const vm = this;  
            
                let file = (event.target.files[0]);
                let file_name =  file['name'];
            
                try {
                    // pregateste datele
                    let formData = new FormData();
                    formData.append("file", file);
                    formData.append("file_name", file_name);
            
                    // apel api incarcare
                    const response = await axios.post(
                        "/api/saveFileInStorage",
                            formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                                onUploadProgress: (event) => {
                                    const percentage = Math.round((100 * event.loaded) / event.total);
                                },
                            });
                        if(type_file=='cv')
                        {vm.current_cv_file = file_name}
                            else 
                        {vm.current_ml_file=file_name}
                } catch (error) {
                    if (error.response) { // get response with a status code not in range 2xx
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                    } else if (error.request) { // no response
                        console.log(error.request);
                    } else { // Something wrong in setting up the request
                        console.log('Error', error.message);
                    }
                    console.log(error.config);
                }
            },
              
        },
    });
});
